export default __webpack_public_path__ + "assets/objectTypeClicked/placesubtype1_peleks.png";